import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import {
  Box,
  Divider,
  Drawer,
  Hidden,
  Link,
  List,
  ListSubheader,
  makeStyles,
  Avatar,
} from '@material-ui/core';
import Logo from 'components/Logo';
import AuthService from 'services/AuthService';
import { Image } from 'components';
import endPoints from 'endPoints/endPoints';
import navConfig from './navConfig';
import renderNavItems from './renderNavItems';

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256,
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)',
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64,
    borderRadius: 50,
  },
}));

function NavBar({ openMobile, onMobileClose, thumbnail }) {
  const classes = useStyles();
  const location = useLocation();
  const [user, setUser] = useState('');

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    const getUserInfo = async () => {
      const { user_name: userName } = await AuthService.getSessionInfo();
      setUser(userName);
    };
    getUserInfo();
    // eslint-disable-next-line
  }, [location.pathname]);

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <Hidden lgUp>
          <Box p={2} display="flex" justifyContent="center">
            <RouterLink to="/">
              <Logo />
            </RouterLink>
          </Box>
        </Hidden>
        <Box p={2}>
          <Box display="flex" justifyContent="center">
            <RouterLink to="/app/miinformacionpersonal">
              {thumbnail === null && (
                <Avatar
                  alt="User"
                  className={classes.avatar}
                  src="/static/images/avatars/avatar_1.png"
                />
              )}
              {thumbnail !== null && (
                <Image
                  url={`${endPoints.general.maestros.images.base}/${thumbnail}`}
                  className={classes.avatar}
                  alt="imagen-usuario"
                />
              )}
            </RouterLink>
          </Box>
          <Box mt={2} textAlign="center">
            <Link
              component={RouterLink}
              to="/app/miinformacionpersonal"
              variant="h5"
              color="textPrimary"
              underline="none"
            >
              {`${user}`}
            </Link>
          </Box>
        </Box>
        <Divider />
        <Box p={2}>
          {navConfig.map((config, key) => (
            <List
              key={`${String(key)}`}
              subheader={(
                <ListSubheader disableGutters disableSticky>
                  {config.subheader}
                </ListSubheader>
              )}
            >
              {renderNavItems({
                items: config.items,
                pathname: location.pathname,
              })}
            </List>
          ))}
        </Box>
      </PerfectScrollbar>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
}

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
  thumbnail: PropTypes.string,
};

export default NavBar;
